import type { Scope } from './scope';

import { bootstrapImageAutoFill } from './fixers/imageAutoFill';
import { bootstrapFooterData } from './fixers/footerInvalidData';

export const bootstrap = (scope: Scope) => {
  bootstrapImageAutoFill(scope);
  bootstrapFooterData(scope);
};
